import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked, AfterContentInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

import { VrAutocomplete } from './models/vr-autocomplete';

const VRC_AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcAutocompleteComponent),
  multi: true
};

@Component({
  selector: 'vrc-autocomplete',
  templateUrl: './vrc-autocomplete.component.html',
  styleUrls: ['./vrc-autocomplete.component.scss'],
  providers: [VRC_AUTOCOMPLETE_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcAutocompleteComponent extends VrAutocomplete implements AfterContentInit, AfterViewChecked {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterContentInit(): void {
    this.isCurrentInit();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

}
